import { FormGroup } from '@angular/forms';

export const getInputValue = <T>(form: FormGroup, key: string): T => {
  const abstractControl = form.get(key);
  return (<T>abstractControl?.value);
};
